import { IconProps } from "./types";
import React from "react";

export const ClockFilledIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M12.0002 0.625977C5.71829 0.625977 0.625244 5.71902 0.625244 12.001C0.625244 18.2829 5.71829 23.376 12.0002 23.376C18.2822 23.376 23.3752 18.2829 23.3752 12.001C23.3752 5.71902 18.2822 0.625977 12.0002 0.625977ZM17.2502 13.751H12.0002C11.7682 13.751 11.5456 13.6588 11.3815 13.4947C11.2174 13.3306 11.1252 13.108 11.1252 12.876V5.00098C11.1252 4.76891 11.2174 4.54635 11.3815 4.38226C11.5456 4.21816 11.7682 4.12598 12.0002 4.12598C12.2323 4.12598 12.4549 4.21816 12.619 4.38226C12.7831 4.54635 12.8752 4.76891 12.8752 5.00098V12.001H17.2502C17.4823 12.001 17.7049 12.0932 17.869 12.2573C18.0331 12.4214 18.1252 12.6439 18.1252 12.876C18.1252 13.108 18.0331 13.3306 17.869 13.4947C17.7049 13.6588 17.4823 13.751 17.2502 13.751Z"
      fill={fill}
    />
  </svg>
);
